import React from 'react';

import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

import { cn } from '@/lib/utils';

export interface TabItem {
  value: string;
  label: string | React.ReactNode;
  content: React.ReactNode;
  dataTestId?: string;
}

export function TabsContainer({
  tabs,
  defaultValue,
  value,
  onValueChange,
  hideTabs,
  forceMount = false,
  tabsListClassName,
}: {
  tabs: TabItem[];
  defaultValue: string;
  value?: string;
  onValueChange?: (value: string) => void;
  hideTabs?: boolean;
  forceMount?: boolean;
  tabsListClassName?: string;
}) {
  return (
    <Tabs
      defaultValue={defaultValue}
      value={value}
      className="w-full"
      onValueChange={onValueChange}
    >
      {!hideTabs && (
        <TabsList
          className={cn(
            `grid grid-cols-${tabs.length} bg-primary/10 mb-5 w-full`,
            tabsListClassName,
          )}
        >
          {tabs.map(tab => (
            <TabsTrigger
              key={tab.value}
              value={tab.value}
              data-testid={tab.dataTestId}
              className="text-primary-dark data-[state=active]:text-primary-dark font-medium"
            >
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>
      )}

      {tabs.map(tab => (
        <TabsContent
          key={tab.value}
          value={tab.value}
          className="focus-visible:outline-none focus-visible:ring-0"
          {...(forceMount && { forceMount: true })}
        >
          {forceMount ? (
            <div style={{ display: value === tab.value ? 'block' : 'none' }}>{tab.content}</div>
          ) : (
            tab.content
          )}
        </TabsContent>
      ))}
    </Tabs>
  );
}
